<template>
    <!-- 用户列表 -->
    <vRoleManagement :postList="postList" v-if="flag"></vRoleManagement>
</template>
<script>
import vRoleManagement from '../listComponent/jurisdiction/roleManagementComponent.vue';
export default {
    name: 'roleManagement',
    components: {
        vRoleManagement
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                name: true,
                mobile: true,
                code: true,
                status: true,
                addBtn: true,
                delateBtn: true,
                searchBtn: true,
                resetBtn: true,
                setBtn: true
            },
            flag: false
        };
    },

    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>